import {slideToggle} from './tools';

export default function initializeCollapseElements() {
    initializeCollapseSection();
}

function initializeCollapseSection() {
    document.querySelectorAll('.collapse-item').forEach(parent => {
        let item = parent.querySelector('.collapse-item__title-container'),
            text = parent.querySelector('.collapse-item__text'),
            openedClass = 'collapse-item--opened';

        collapseItem(item, parent, text, openedClass);
    });
}

function collapseItem(item, parent, text, openedClass) {
    if (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();

            parent.classList.toggle(openedClass);

            if(parent.classList.contains(openedClass)) {
                item.setAttribute('aria-expanded', true);
                text.setAttribute('aria-hidden', false);
            }
            else {
                item.setAttribute('aria-expanded', false);
                text.setAttribute('aria-hidden', true);
            }

            slideToggle(text);
        });
    }
}